import { render, staticRenderFns } from "./AiSyntaxKeywordEditor.vue?vue&type=template&id=a16cc78e&scoped=true&"
import script from "./AiSyntaxKeywordEditor.vue?vue&type=script&lang=ts&"
export * from "./AiSyntaxKeywordEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AiSyntaxKeywordEditor.vue?vue&type=style&index=0&id=a16cc78e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16cc78e",
  null
  
)

export default component.exports